"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductByRules = exports.getCategoriesTree = exports.getProductsByProductOffering = exports.getProductsByCategory = exports.getProductByAlias = void 0;
const bit_utils_ada_byron_1 = require("@gcloud-npm/bit.utils.ada-byron");
const bit_utils_monitoring_utils_1 = require("@gcloud-npm/bit.utils.monitoring-utils");
const bit_utils_types_1 = require("@gcloud-npm/bit.utils.types");
const bit_utils_request_1 = __importStar(require("@gcloud-npm/bit.utils.request"));
const bit_utils_sonda_1 = __importDefault(require("@gcloud-npm/bit.utils.sonda"));
var PATHS;
(function (PATHS) {
    PATHS["GET_PRODUCTS_LIST"] = "/v1/orion/standard-api/products/list";
    PATHS["GET_PRODUCT_BY_ALIAS"] = "/v1/orion/standard-api/products/alias/";
    PATHS["GET_CATEGORIES_TREE"] = "/v1/orion/standard-api/categories/tree";
    PATHS["GET_PRODUCT_BY_RULES"] = "/v1/orion/standard-api/products/ionCode";
    PATHS["GET_PRODUCTS_BY_PRODUCT_OFFERING"] = "/v1/orion/standard-api/products/productOffering/";
})(PATHS || (PATHS = {}));
var getProductsByCategorySuccess = function (xhr) {
    var response = JSON.parse(xhr.response);
    return response.responseList;
};
var getProductsByProductOfferingSuccess = function (xhr) {
    var response = JSON.parse(xhr.response);
    return response;
};
var getProductByAliasSuccess = function (xhr) {
    var response = JSON.parse(xhr.response);
    return response;
};
var getCategoriesTreeSuccess = function (xhr) {
    var response = JSON.parse(xhr.response);
    return response;
};
var getProductByRulesSuccess = function (xhr) {
    var response = JSON.parse(xhr.response);
    return response;
};
var getProductByAlias = function (data, context, idFront) {
    if (idFront === void 0) {
        idFront = 'VT';
    }
    var idRequest = bit_utils_monitoring_utils_1.api.getUUID(idFront);
    var sonda = new bit_utils_sonda_1.default({
        eventName: 'ORION.GET_PRODUCT_BY_ALIAS',
        context: context,
        uniqueId: idRequest,
        origin: bit_utils_ada_byron_1.processName,
    });
    var _a = context.environment, connectionData = _a.orion, name = _a.name;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var alias = data.alias;
    var URL_API = "".concat(host).concat(PATHS.GET_PRODUCT_BY_ALIAS).concat(alias, "?").concat(idRequest, "&rules={}");
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getProductByAlias', name);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onSuccess: function (response) {
                return getProductByAliasSuccess(response);
            },
            sonda: sonda,
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.getProductByAlias = getProductByAlias;
var getProductsByCategory = function (data, context, idFront) {
    if (idFront === void 0) {
        idFront = 'VT';
    }
    var idRequest = bit_utils_monitoring_utils_1.api.getUUID(idFront);
    var sonda = new bit_utils_sonda_1.default({
        eventName: 'ORION.GET_PRODUCTS_LIST',
        context: context,
        uniqueId: idRequest,
        origin: bit_utils_ada_byron_1.processName,
    });
    var _a = context.environment, connectionData = _a.orion, name = _a.name;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var category = data.category;
    var URL_API = "".concat(host).concat(PATHS.GET_PRODUCTS_LIST, "?categories=").concat(category, "&").concat(idRequest, "&rules={}");
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getProductsByCategory', name);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onSuccess: function (response) {
                return getProductsByCategorySuccess(response);
            },
            sonda: sonda,
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.getProductsByCategory = getProductsByCategory;
var getProductsByProductOffering = function (data, context, idFront) {
    if (idFront === void 0) {
        idFront = 'VT';
    }
    var idRequest = bit_utils_monitoring_utils_1.api.getUUID(idFront);
    var sonda = new bit_utils_sonda_1.default({
        eventName: 'ORION.GET_PRODUCTS_BY_PRODUCT_OFFERING',
        context: context,
        uniqueId: idRequest,
        origin: bit_utils_ada_byron_1.processName,
    });
    var _a = context.environment, connectionData = _a.orion, name = _a.name;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var productOffering = data.productOffering;
    var rules = { tipoCliente: 'no-cliente' };
    if (context.userType === bit_utils_ada_byron_1.USER_TYPES.CLIENT) {
        rules.tipoCliente = 'cliente';
    }
    var URL_API = "".concat(host).concat(PATHS.GET_PRODUCTS_BY_PRODUCT_OFFERING).concat(productOffering, "?").concat(idRequest, "&rules=").concat(JSON.stringify(rules));
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getProductsByProductOffering', name);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onSuccess: function (response) {
                return getProductsByProductOfferingSuccess(response);
            },
            sonda: sonda,
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.getProductsByProductOffering = getProductsByProductOffering;
var getCategoriesTree = function (data, context, idFront) {
    if (idFront === void 0) {
        idFront = 'VT';
    }
    var idRequest = bit_utils_monitoring_utils_1.api.getUUID(idFront);
    var sonda = new bit_utils_sonda_1.default({
        eventName: 'ORION.GET_CATEGORIES_TREE',
        context: context,
        uniqueId: idRequest,
        origin: bit_utils_ada_byron_1.processName,
    });
    var _a = context.environment, connectionData = _a.orion, name = _a.name;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var category = data.category;
    var URL_API = "".concat(host).concat(PATHS.GET_CATEGORIES_TREE, "?id=").concat(category, "&").concat(idRequest, "&rules={}");
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getCategoriesTree', name);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onSuccess: function (response) {
                return getCategoriesTreeSuccess(response);
            },
            sonda: sonda,
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.getCategoriesTree = getCategoriesTree;
var getProductByRules = function (data, context, idFront) {
    if (idFront === void 0) {
        idFront = 'webM';
    }
    var idRequest = bit_utils_monitoring_utils_1.api.getUUID(idFront);
    var sonda = new bit_utils_sonda_1.default({
        eventName: 'ORION.GET_PRODUCT_BY_RULES',
        context: context,
        uniqueId: idRequest,
        origin: bit_utils_ada_byron_1.processName,
    });
    var _a = context.environment, connectionData = _a.orion, name = _a.name;
    var host = connectionData.endpoint, headers = connectionData.headers;
    var rules = data.rules, ionCode = data.ionCode;
    var URL_API = "".concat(host).concat(PATHS.GET_PRODUCT_BY_RULES, "/").concat(ionCode, "?rules=").concat(encodeURIComponent(rules), "&").concat(idRequest);
    var mockInfo = (0, bit_utils_request_1.getMockedInfo)('getProductByRules', name);
    try {
        var request = new bit_utils_request_1.default({
            method: bit_utils_types_1.MethodType.GET,
            endpoint: URL_API,
            onSuccess: function (response) {
                return getProductByRulesSuccess(response);
            },
            sonda: sonda,
            headers: headers,
            mockInfo: mockInfo,
        });
        return request.makeRequest();
    }
    catch (err) {
        sonda.errorJs(err);
        return null;
    }
};
exports.getProductByRules = getProductByRules;
//# sourceMappingURL=index.js.map